var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c("p", { staticClass: "menu-label" }, [
      _c("span", { staticClass: "title is-6" }, [
        _vm._v(" Return No. " + _vm._s(_vm.returnDetail.number) + " "),
      ]),
    ]),
    _c("div", [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column field" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "control has-icons-right" },
            [
              _vm.$company.info.countryCode === "AU"
                ? _c("the-mask", {
                    ref: "abn",
                    staticClass: "input abn",
                    class: {
                      "is-static": _vm.vendorId === "",
                      "is-danger": _vm.$v.entitySummaries.vendorAbn.$error,
                    },
                    attrs: {
                      id: "abn",
                      name: "abn",
                      disabled: _vm.readOnly,
                      placeholder: "Vendor ABN",
                      mask: ["## ### ### ###"],
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeValue()
                      },
                    },
                    model: {
                      value: _vm.returnDetail.abn,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnDetail, "abn", $$v)
                      },
                      expression: "returnDetail.abn",
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.returnDetail.abn,
                        expression: "returnDetail.abn",
                      },
                    ],
                    ref: "abn",
                    staticClass: "input is-uppercase",
                    attrs: { id: "abn", maxlength: "12" },
                    domProps: { value: _vm.returnDetail.abn },
                    on: {
                      change: function ($event) {
                        return _vm.changeValue()
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.returnDetail, "abn", $event.target.value)
                      },
                    },
                  }),
              !_vm.$v.entitySummaries.vendorAbn.$error &&
              _vm.$v.entitySummaries.vendorAbn.validAbn &&
              _vm.$v.entitySummaries.vendorAbn.minLength &&
              _vm.$v.entitySummaries.vendorAbn.required &&
              _vm.$company.info.countryCode === "AU"
                ? _c(
                    "span",
                    { staticClass: "icon has-text-success is-right" },
                    [_c("i", { staticClass: "mdi mdi-check mdi-18px" })]
                  )
                : _vm._e(),
              _vm.returnDetail.abn === "" && _vm.$company.info.isWithHold
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      " This vendor does not have an ABN. You will be required to with hold " +
                        _vm._s(_vm.$userInfo.withHoldingTax) +
                        "% of the invoice. "
                    ),
                  ])
                : _vm.$v.entitySummaries &&
                  !_vm.$v.entitySummaries.vendorAbn.validAbn
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("ABN is invalid."),
                  ])
                : _vm._e(),
              _vm.$v.entitySummaries &&
              !_vm.$v.entitySummaries.vendorAbn.minLength
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(
                      "ABN must be at least " +
                        _vm._s(
                          _vm.$v.entitySummaries.vendorAbn.$params.minLength.min
                        ) +
                        " letters."
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "column field" }, [
          _c("div", { staticClass: "control" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "field is-narrow is-pulled-left" },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  on: {
                    input: function ($event) {
                      _vm.returnDetail.date =
                        _vm.$filters.fromISOWithCurrentTime(
                          $event.toISOString()
                        )
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _vm.returnDetail.id === "" || _vm.readOnly
                                  ? _c("input", {
                                      staticClass: "input",
                                      class: {
                                        "is-danger":
                                          _vm.$v.entitySummaries.returnDate
                                            .$invalid,
                                      },
                                      attrs: {
                                        type: "text",
                                        readonly: "",
                                        disabled: true,
                                        placeholder: "Select Credit Date",
                                      },
                                      domProps: {
                                        value: _vm.$filters.formatDateTimezone(
                                          _vm.returnDetail.date,
                                          _vm.$userInfo.locale
                                        ),
                                      },
                                    })
                                  : _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          class: {
                                            "is-danger":
                                              _vm.$v.entitySummaries.returnDate
                                                .$invalid,
                                          },
                                          attrs: {
                                            type: "text",
                                            readonly: "",
                                            placeholder: "Select Credit Date",
                                          },
                                          domProps: { value: inputValue },
                                          on: {
                                            input: function ($event) {
                                              return _vm.changeValue()
                                            },
                                          },
                                        },
                                        inputEvents
                                      )
                                    ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                                !_vm.$v.entitySummaries.returnDate.required
                                  ? _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v("Return Date is required. ")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.returnDetail.date,
                    callback: function ($$v) {
                      _vm.$set(_vm.returnDetail, "date", $$v)
                    },
                    expression: "returnDetail.date",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Vendor ABN")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label is" }, [_vm._v("Return Date")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }